import { InfoIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";

type MacrosPopoverProps = {
  macros: { name: string; code: string }[];
};

export default function MacrosPopover(props: MacrosPopoverProps) {
  const { macros } = props;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="icon" className="size-5">
          <InfoIcon className="size-4 text-muted-foreground" />
        </Button>
      </PopoverTrigger>
      <PopoverContent
        align="start"
        className="w-80"
        onClick={(e) => e.preventDefault()}
      >
        <dl className="space-y-2">
          {macros.map((macro) => (
            <div className="grid grid-cols-[4fr,1fr] gap-x-4" key={macro.code}>
              <dt className="text-sm">{macro.name}</dt>
              <dd className="text-sm text-muted-foreground">%{macro.code}%</dd>
            </div>
          ))}
        </dl>
      </PopoverContent>
    </Popover>
  );
}
